// extracted by mini-css-extract-plugin
module.exports = {"offer":"WCSOffer_offer__z801f","offer__text":"WCSOffer_offer__text__2gM07"};